import { HttpClient } from '@opallabs/api'

const buildAssetReferencePayload = ({ data }) => ({
  data: {
    type: 'asset_reference',
    attributes: {
      asset_uuid: data.id,
      filename: data.attributes.file_name,
      filesize: data.attributes.bytes,
      full_url: data.attributes.url,
      height: data.attributes.height,
      width: data.attributes.width,
    },
    relationships: { ...data.relationships },
  },
})

const postAssetReference = (asset) => {
  const url = '/api/v1/asset_references'
  const payload = buildAssetReferencePayload(asset)

  return HttpClient().post(url, payload)
}

export default postAssetReference
